module.exports = __webpack_public_path__ + "static/media/fa-brands-400.45813ba6.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-brands-400.eot
// module id = 299
// module chunks = 0